export const SET_ERROR_NOTIFICATION = 'SET_NOTIFICATION'

export const CLEAR_ERROR_NOTIFICATION = 'CLEAR_NOTIFICATION'

export const SET_APP_NOTIFICATION = 'SET_APP_NOTIFICATION'

export const SET_CRITICAL_NOTIFICATION = 'SET_CRITICAL_NOTIFICATION'

export const CLEAR_CRITICAL_NOTIFICATION = 'CLEAR_CRITICAL_NOTIFICATION'

export const CLEAR_APP_NOTIFICATION = 'CLEAR_APP_NOTIFICATION'

export const SET_MASTER_ACTIVE = 'SET_MASTER_ACTIVE'
